// Mirrors CoachPortal.jsx's CATEGORIES (the coach-write side of the same
// `notes` data) — a note's category is coach-authored, so the label/color
// mapping here must match what the coach saw when they picked it.
export const NOTE_CATEGORIES = {
  general:   { label: "General", color: "#64748B" },
  technique: { label: "Technique", color: "#0B2E59" },
  mindset:   { label: "Mindset", color: "#D4A017" },
  fitness:   { label: "Fitness", color: "#16A34A" },
  tactical:  { label: "Tactical", color: "#7C3AED" },
};
